import { createFileRoute, Navigate } from '@tanstack/react-router';

function Index() {
  // Redirect to dashboard (demo page with all components)
  return <Navigate to="/dashboard" />;
}

export const Route = createFileRoute('/')({
  component: Index,
});
